import * as yup from 'yup';

const PhoneValidationSchema = yup
  .string()
  .matches(/^[A-Za-z0-9 \-()+]{0,20}$/, { message: 'Invalid Phone Number' });

export default PhoneValidationSchema;
